// extracted by mini-css-extract-plugin
module.exports = {"root":"Log_root__1NSfi","title":"Log_title__Pl3hd"};